<template>
  <div
    class="absolute inset-0 w-screen h-screen flex items-center justify-center z-10"
  >
    <div
      class="w-[95%] sm:w-[90%] max-w-[763px] p-4 sm:p-8 relative mx-auto my-auto shadow-lg bg-white rounded-[10px] z-10 max-h-[95vh] overflow-y-auto"
    >
      <button
        aria-label="Close modal"
        class="absolute top-2 right-2 sm:top-4 sm:right-4 w-12 h-12 sm:w-8 sm:h-8 flex items-center justify-center text-black hover:text-gray-600 transition-colors z-50"
        @click="emit('close')"
      >
        <svg
          class="w-7 h-7 sm:w-5 sm:h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          stroke-width="2.5"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>

      <div class="text-center">
        <h2 class="text-2xl sm:text-[32px] font-bold text-black mb-2 sm:mb-3">
          Start Designing
        </h2>
        <p
          class="text-xs sm:text-sm font-semibold text-black mb-6 sm:mb-8 px-4"
        >
          Get started by choosing how you'd like to create your space:
        </p>

        <div
          class="flex flex-col sm:flex-row gap-4 sm:gap-6 items-center justify-center mb-6 sm:mb-8 px-2"
        >
          <button
            class="flex flex-col items-center cursor-pointer group w-full sm:w-auto max-w-[320px]"
            @click="emit('gallery')"
          >
            <div
              class="bg-[#f7f6f5] rounded-[5px] w-full sm:w-[287px] aspect-[287/166] flex items-center justify-center mb-3 sm:mb-4 group-hover:bg-[#eeeded] transition-colors"
            >
              <img
                src="/img/gallery-pattern-icon.svg"
                alt="Gallery pattern"
                class="w-[70%] h-[70%] object-contain"
              />
            </div>
            <h3 class="text-lg sm:text-xl font-bold text-black mb-1 sm:mb-2">
              Customize a Design
            </h3>
            <p class="text-xs text-black">Customize a premade design.</p>
          </button>

          <div class="text-lg sm:text-xl font-bold text-black my-2 sm:my-0">
            OR
          </div>

          <button
            class="flex flex-col items-center cursor-pointer group w-full sm:w-auto max-w-[320px]"
            @click="emit('scratch')"
          >
            <div
              class="bg-[#f7f6f5] rounded-[5px] w-full sm:w-[287px] aspect-[287/166] flex items-center justify-center mb-3 sm:mb-4 group-hover:bg-[#eeeded] transition-colors"
            >
              <img
                src="/img/grid-pattern-icon.svg"
                alt="Grid pattern"
                class="w-full h-full"
              />
            </div>
            <h3 class="text-lg sm:text-xl font-bold text-black mb-1 sm:mb-2">
              Create from Scratch
            </h3>
            <p class="text-xs text-black">Start a new design from scratch.</p>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const emit = defineEmits(["close", "gallery", "scratch"]);
</script>
